module.exports = __webpack_public_path__ + "img/fahongbao.f30d7c86.gif";